// extracted by css-extract-rspack-plugin
export default {"wrapper":"src-modules-auth-components-AuthInput-AuthInput-module__wrapper-pWnvO2","inputWrapper":"src-modules-auth-components-AuthInput-AuthInput-module__inputWrapper-jIHmUK","hasError":"src-modules-auth-components-AuthInput-AuthInput-module__hasError-tqqE06","authInput":"src-modules-auth-components-AuthInput-AuthInput-module__authInput-TQHbzu","hasActionButton":"src-modules-auth-components-AuthInput-AuthInput-module__hasActionButton-sjDQXW","error":"src-modules-auth-components-AuthInput-AuthInput-module__error-VpZNVx"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"wrapper\":\"src-modules-auth-components-AuthInput-AuthInput-module__wrapper-pWnvO2\",\"inputWrapper\":\"src-modules-auth-components-AuthInput-AuthInput-module__inputWrapper-jIHmUK\",\"hasError\":\"src-modules-auth-components-AuthInput-AuthInput-module__hasError-tqqE06\",\"authInput\":\"src-modules-auth-components-AuthInput-AuthInput-module__authInput-TQHbzu\",\"hasActionButton\":\"src-modules-auth-components-AuthInput-AuthInput-module__hasActionButton-sjDQXW\",\"error\":\"src-modules-auth-components-AuthInput-AuthInput-module__error-VpZNVx\"}";
        // 1793874320291
        var cssReload = require("../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  